import { useTypedSelector } from '../../../../../../../hooks/useTypedSelector';
import nls from '../../../../nls/pt-BR.json';
import { studiesSelector } from '../../../../redux/studies.reducer';
import { CalculateLayoutInstallmentsForm } from './calculateInstallmentsForm';

export const CalculateInstallmentsPrimary: React.FC = () => {
  const { layoutsValuationPrimaryResponse, currentStep } =
    useTypedSelector(studiesSelector);

  return (
    <>
      <p className="helper-text" style={{ margin: '16px 0px' }}>
        <span>
          {nls.studyCreationGuide.steps.step5.calculateInstallmentsHelper}{' '}
        </span>
        <span style={{ fontWeight: 700 }}>
          {nls.studyCreationGuide.steps.step5.primaryMarket}:
        </span>
      </p>
      {layoutsValuationPrimaryResponse && (
        <CalculateLayoutInstallmentsForm
          data={layoutsValuationPrimaryResponse}
          currentStep={currentStep}
          marketType="primary"
        />
      )}
    </>
  );
};
